<template>
  <div>
    <el-drawer
      :visible.sync="drawer"
      :close-on-press-escape="false"
      :wrapperClosable="false"
      size="80%"
      :before-close="beforeClose"
      @close="closeDrawer"
    >
      <template slot="title">
        <div style="display: flex; align-items: center">
          <el-button
            style="
              width: 50px;
              margin-right: 10px;
              display: flex;
              justify-content: center;
              align-items: center;
            "
            type="primary"
            @click="beforeClose(false)"
            >关闭</el-button
          >
          <span
            v-html="
              disabled
                ? `设备资料信息详情---${TreeName}`
                : `填写设备资料信息---${TreeName}`
            "
          ></span>
        </div>
      </template>
      <div v-loading="loading" style="width: 100%; overflow-x: hidden">
        <el-card
          style="
            height: calc(100vh - 70px);
            overflow-y: auto;
            overflow-x: hidden;
            width: 100%;
            position: relative;
          "
        >
          <div style="width: 100%; display: flex">
            <div style="width: calc(100% - 200px)">
              <div style="width: 100%">
                <div
                  style="
                    display: flex;
                    align-items: center;
                    width: calc(100%);
                    margin-bottom: 10px;
                    padding-left: 10px;
                    padding-right: 10px;
                    box-sizing: border-box;
                    justify-content: right;
                  "
                >
                  <!-- <el-button
                  .0
                    type="danger"
                    style="margin-right: 10px"
                    @click="rejectVisible = true"
                    v-if="DataInfo.Status == 4"
                    >查看驳回原因</el-button
                  > -->
                  <el-tag
                    type="warning"
                    v-if="DataInfo.Status == 1"
                    size="medium"
                    >已提交</el-tag
                  >
                  <el-tag
                    type="success"
                    v-if="DataInfo.Status == 2 || DataInfo.Status == 3"
                    size="medium"
                    >已审核</el-tag
                  >
                  <el-tag
                    type="danger"
                    v-if="DataInfo.Status == 4"
                    size="medium"
                    >已驳回</el-tag
                  >
                </div>
                <div
                  style="
                    margin-bottom: 10px;
                    font-size: 14px;
                    display: flex;
                    align-items: center;
                  "
                  id="Device"
                >
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      width: calc(100% / 3);
                      margin-bottom: 10px;
                      padding-left: 10px;
                      padding-right: 10px;
                      box-sizing: border-box;
                    "
                  >
                    <div style="width: 130px">
                      <span style="color: red">*</span> 安装位置：
                    </div>
                    <el-select
                      v-model="DataInfo.InstallationArea"
                      placeholder="请选择"
                      :disabled="
                        disabled || DeviceId
                          ? true
                          : false || ParentDeviceId
                          ? true
                          : false
                      "
                      style="width: calc(100% - 130px)"
                      size="mini"
                      @change="changeInstallationArea"
                      filterable
                      clearable
                    >
                      <el-option
                        v-for="val in InstallationAreaData"
                        :key="val.Id"
                        :label="val.DicName"
                        :value="val.Id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      width: calc(100% / 3);
                      margin-bottom: 10px;
                      padding-left: 10px;
                      padding-right: 10px;
                      box-sizing: border-box;
                    "
                    v-if="InstallationAreaValue === 'Indoor'"
                  >
                    <div style="width: 130px">
                      <span style="color: red">*</span>楼栋：
                    </div>
                    <el-select
                      v-model="DataInfo.BuildingId"
                      placeholder="请选择"
                      :disabled="
                        disabled || DeviceId
                          ? true
                          : false || ParentDeviceId
                          ? true
                          : false
                      "
                      style="width: calc(100% - 130px)"
                      size="mini"
                      @change="changeBuilding"
                      filterable
                      clearable
                    >
                      <el-option
                        v-for="val in BuildingData"
                        :key="val.Id"
                        :label="`${
                          val.BuildingCode ? '【' + val.BuildingCode + '】' : ''
                        }${val.BuildingName || ''}`"
                        :value="val.Id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      width: calc(100% / 3);

                      margin-bottom: 10px;
                      padding-left: 10px;
                      padding-right: 10px;
                      box-sizing: border-box;
                    "
                    v-if="
                      InstallationAreaValue === 'Indoor' &&
                      DataInfo.BuildingId != '其他'
                    "
                  >
                    <div style="width: 120px">
                      <span style="color: red">*</span>楼层：
                    </div>
                    <el-select
                      v-model="DataInfo.BuildingFloor"
                      placeholder="请选择"
                      filterable
                      :disabled="
                        disabled || DeviceId
                          ? true
                          : false || ParentDeviceId
                          ? true
                          : false
                      "
                      clearable
                      style="width: calc(100% - 130px)"
                      size="mini"
                    >
                      <el-option
                        v-for="(val, index) in BuildingFloorList"
                        :key="val + index"
                        :label="val"
                        :value="val"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>

                <el-collapse v-model="collapseValue">
                  <el-collapse-item
                    v-for="(ele, index) in TabData"
                    :key="ele.DicValue"
                    :name="ele.DicValue"
                    :id="ele.DicValue"
                  >
                    <template slot="title">
                      <div
                        style="
                          width: calc(100% - 50px);
                          display: flex;
                          align-items: center;
                        "
                      >
                        <div
                          style="
                            width: calc(100% - 130px);
                            font-weight: bold;
                            font-size: 18px;
                          "
                        >
                          {{ index + 1 }}.{{ ele.DicName }}
                        </div>
                      </div>
                    </template>
                    <div
                      style="
                        width: 100%;
                        border-top: 1px solid #ebeef5;
                        margin-bottom: 5px;
                      "
                    ></div>
                    <!-- //除了文档信息和部件信息有保存外其他都没有保存 -->
                    <div
                      style="text-align: right; margin-bottom: 10px"
                      v-if="
                        ele.DicValue !== 'DocumentInformation' &&
                        ele.DicValue !== 'Device_Components'
                      "
                    >
                      <el-button
                        v-if="!disabled"
                        type="primary"
                        @click.stop="saveData(ele.DicValue, ele.DicName)"
                        >保存</el-button
                      >
                    </div>
                    <!-- 字段信息 -->
                    <!-- //非 文档信息 配件信息 部件信息 -->
                    <!-- 基本信息 配置信息 -->
                    <div
                      v-if="
                        ele.DicValue !== 'DocumentInformation' &&
                        ele.DicValue !== 'SparePartsInformation' &&
                        ele.DicValue !== 'Device_Components'
                      "
                      style="display: flex; width: 100%; flex-wrap: wrap"
                    >
                      <div
                        v-for="item in TemplateData[ele.DicValue]"
                        :key="item.FiledKey"
                        :style="`width:${
                          100 / item.width
                        }%;margin-bottom:10px;padding-left:10px;padding-right:10px;box-sizing: border-box;`"
                      >
                        <div
                          style="display: flex; width: 100%; font-size: 14px"
                        >
                          <span
                            style="
                              display: inline-block;
                              width: 130px;
                              display: flex;
                              align-items: center;
                            "
                            ><span
                              style="color: red"
                              v-if="item.IsEnable || item.disabled"
                              >*</span
                            >{{ item.FieldName }}</span
                          >
                          <el-input
                            v-model="DataInfo[ele.DicValue][item.FiledKey]"
                            placeholder="请输入内容"
                            v-if="item.ComponentType === 'InputText'"
                            style="width: calc(100% - 130px)"
                            type="textarea"
                            :rows="item.rows || 1"
                            resize="none"
                            :disabled="disabled"
                            size="mini"
                          ></el-input>
                          <el-input
                            v-model="DataInfo[ele.DicValue][item.FiledKey]"
                            placeholder="请输入内容"
                            v-if="item.ComponentType === 'InputNumber'"
                            style="width: calc(100% - 130px)"
                            type="number"
                            :disabled="disabled"
                            resize="none"
                            size="mini"
                          ></el-input>
                          <el-date-picker
                            v-model="DataInfo[ele.DicValue][item.FiledKey]"
                            type="date"
                            placeholder="选择日期"
                            v-if="
                              item.ComponentType === 'DatePicker' &&
                              DataInfo[ele.DicValue]
                            "
                            size="mini"
                            :disabled="disabled"
                            value-format="yyyy-MM-dd"
                            style="width: calc(100% - 130px)"
                          >
                          </el-date-picker>
                          <el-radio-group
                            v-model="DataInfo[ele.DicValue][item.FiledKey]"
                            v-if="item.ComponentType === 'Radio'"
                            style="
                              width: calc(100% - 130px);
                              display: flex;
                              align-items: center;
                            "
                            size="mini"
                            :disabled="disabled"
                          >
                            <el-radio
                              v-for="val in item.Source
                                ? JSON.parse(item.Source)
                                : []"
                              :label="val.value"
                              :key="val.value"
                            >
                              {{ val.value }}</el-radio
                            >
                          </el-radio-group>
                          <el-select
                            v-model="DataInfo[ele.DicValue][item.FiledKey]"
                            v-if="item.ComponentType === 'Select'"
                            placeholder="请选择"
                            :disabled="disabled"
                            style="width: calc(100% - 130px)"
                            size="mini"
                          >
                            <el-option
                              v-for="val in item.Source
                                ? JSON.parse(item.Source)
                                : []"
                              :key="val.value"
                              :label="val.value"
                              :value="val.value"
                            >
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                    </div>

                    <!-- 文档信息 -->
                    <div
                      v-if="ele.DicValue === 'DocumentInformation'"
                      style="
                        display: flex;
                        width: 100%;
                        flex-wrap: wrap;

                        position: relative;
                      "
                    >
                      <div
                        style="
                          width: 100%;
                          background-color: #fff;
                          padding: 10px;
                          border-radius: 5px;
                          text-align: right;
                          position: sticky;
                          top: 0;
                          right: 0;
                          z-index: 99;
                        "
                        v-if="!disabled"
                      >
                        <!-- <el-checkbox
                      v-model="isUpCheckbox"
                      @change="upCheckboxChange"
                      style="margin-right: 20px"
                      :disabled="disabled"
                      >全选</el-checkbox
                    >
                    <el-button
                      type="primary"
                      @click="upAllData"
                      size="mini"
                      :disabled="disabled"
                      >上传文档信息</el-button
                    > -->
                        <el-button type="primary" @click="DocumentSubmit(ele)"
                          >保存文档</el-button
                        >
                      </div>

                      <div
                        v-for="item in TemplateData[ele.DicValue]"
                        :key="item.FiledKey"
                        :style="`width:${
                          100 / item.width
                        }%;margin-bottom:10px;padding-left:10px;padding-right:10px;box-sizing: border-box;`"
                      >
                        <el-table
                          style="width: 100%"
                          size="mini"
                          :data="
                            item.device_TypeTwoDocuments.filter((vall) =>
                              item.cList.includes(vall.Type)
                            )
                          "
                          header-row-class-name="header-class"
                        >
                          <!-- <el-table-column
                        type="sele"
                        width="40"
                        align="center"
                        :resizable="false"
                      >
                        <template slot-scope="scope">
                          <el-checkbox
                            :disabled="disabled"
                            v-model="scope.row.checked"
                            @change="checkedChange(scope.row)"
                          ></el-checkbox>
                        </template>
                      </el-table-column> -->
                          <el-table-column
                            type="index"
                            label="序号"
                            width="50"
                            align="center"
                          ></el-table-column>
                          <el-table-column
                            prop="TypeName"
                            :label="item.FieldName"
                            :resizable="false"
                          >
                            <template slot-scope="scope">
                              <span>
                                <span
                                  style="color: red"
                                  v-if="scope.row.disabled"
                                  >*</span
                                >
                                {{ `${scope.row.TypeName}` }}</span
                              >
                              <el-popover
                                placement="bottom-start"
                                v-if="scope.row.Remark"
                                :open-delay="100"
                                width="200"
                                trigger="hover"
                                :content="scope.row.Remark"
                                popper-class="table-popper"
                              >
                                <i
                                  class="el-icon-question"
                                  slot="reference"
                                ></i>
                              </el-popover>
                            </template>
                          </el-table-column>
                          <el-table-column
                            prop="Type"
                            label="文件信息"
                            :resizable="false"
                          >
                            <!-- :before-remove="(file) => beforeRemove(file, item)"
                          :on-remove="
                            (file, fileList) => handleRemove(file, fileList, item)
                          " -->
                            <!-- :on-success="
                            (response, file, fileList) =>
                              handleSuccess(response, file, fileList, item)
                          "
                          :on-error="
                            (err, file, fileList) =>
                              handleError(err, file, fileList, item)
                          " -->
                            <!-- DataInfo[DataInfo.DeviceTab][item.FiledKey]-->
                            <template slot-scope="scope">
                              <el-upload
                                :limit="9"
                                class="upload-demo"
                                :action="
                                  $rootUrl +
                                  `/Base_Manage/Upload/ProjectOssUploadFileByForm?ProjectId=${ProjectId}&UserId=${SupplierId}&type=3&SupplierId=${SupplierId}&DeviceType=${treeId}`
                                "
                                :ref="'upload_' + scope.row.Type"
                                multiple
                                accept="image/*, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                                :before-upload="
                                  (file, fileList) =>
                                    beforeUpload(scope.row, file, fileList)
                                "
                                :disabled="scope.row.IsUpStatus || disabled"
                                :headers="{
                                  Authorization:
                                    'Bearer ' + TokenCache.getToken(),
                                }"
                                :before-remove="
                                  (file) => beforeRemove(file, item)
                                "
                                :file-list="
                                  DataInfo[ele.DicValue][
                                    scope.row.Type + 'List'
                                  ]
                                "
                                :on-exceed="handleExceed"
                                :on-preview="handlePreview"
                                :on-change="
                                  (file, fileList) =>
                                    handleChange(file, fileList, scope.row.Type)
                                "
                                :on-success="
                                  (response, file, fileList) =>
                                    handleSuccess(
                                      response,
                                      file,
                                      fileList,
                                      scope.row
                                    )
                                "
                                :on-error="
                                  (err, file, fileList) =>
                                    handleError(err, file, fileList, scope.row)
                                "
                                :on-remove="
                                  (file, fileList) =>
                                    handleRemove(file, fileList, scope.row)
                                "
                                :auto-upload="true"
                              >
                                <div>
                                  <el-button
                                    size="mini"
                                    type="primary"
                                    :disabled="!DeviceId || disabled"
                                    v-if="!disabled"
                                    :loading="scope.row.IsUpStatus"
                                    >{{
                                      scope.row.IsUpStatus
                                        ? '上传中'
                                        : '选择文件'
                                    }}</el-button
                                  >
                                </div>
                              </el-upload>
                            </template>
                          </el-table-column>
                          <el-table-column
                            prop="TypeName"
                            label="文件大小"
                            :resizable="false"
                          >
                            <template slot-scope="scope">
                              <div style="margin-top: 10px">
                                <div
                                  v-for="item in DataInfo[ele.DicValue][
                                    scope.row.Type + 'List'
                                  ]"
                                  :key="item.uid"
                                  style="
                                    width: 100%;
                                    line-height: 1.8;
                                    margin-top: 5px;
                                    font-size: 14px;
                                  "
                                >
                                  <!-- <div
                                  style="
                                    width: calc(100% - 120px);
                                    display: flex;
                                    align-items: center;
                                  "
                                >
                                  {{ item.name }}
                                </div> -->
                                  <div
                                    style="
                                      width: 120px;
                                      display: flex;
                                      align-items: center;
                                    "
                                  >
                                    {{ setSize(item.size) }}
                                  </div>
                                </div>
                              </div>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="上传状态"
                            width="100"
                            align="center"
                          >
                            <template slot-scope="scope">
                              <i
                                class="el-icon-circle-check"
                                style="font-size: 20px; color: #67c23a"
                                v-if="
                                  DataInfo[ele.DicValue][
                                    scope.row.Type + 'List'
                                  ]?.length > 0 &&
                                  DataInfo[ele.DicValue][
                                    scope.row.Type + 'List'
                                  ]?.every((item) => item.status === 'success')
                                "
                              ></i>
                              <i
                                v-else
                                class="el-icon-circle-close"
                                style="font-size: 20px; color: #f56c6c"
                              ></i>
                            </template>
                          </el-table-column>
                          <!-- <el-table-column
                        prop="options"
                        label="操作"
                        :resizable="false"
                        align="center"
                        width="100"
                      >
                        <template slot-scope="scope">
                          <el-button
                            v-if="!disabled"
                            @click="upData(scope.row)"
                            :loading="scope.row.IsUpStatus"
                            type="primary"
                            size="mini"
                            :disabled="disabled"
                            >{{ scope.row.IsUpStatus ? "上传中" : "上传" }}</el-button
                          >
                        </template>
                      </el-table-column> -->
                        </el-table>
                      </div>
                    </div>
                    <!-- 部件信息 -->
                    <div
                      v-if="ele.DicValue === 'Device_Components'"
                      style="padding: 0px 20px"
                    >
                      <el-collapse
                        :value="
                          TemplateData[ele.DicValue].map(
                            (item) => item.ComponentDeviceType
                          )
                        "
                      >
                        <el-collapse-item
                          v-for="item in TemplateData[ele.DicValue]"
                          :key="item.FiledKey"
                          :title="item.ComponentDeviceTypeName"
                          :name="item.ComponentDeviceType"
                        >
                          <template slot="title">
                            <div
                              style="
                                width: calc(100% - 50px);
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                              "
                            >
                              <div style="font-weight: bold">
                                {{ item.ComponentDeviceTypeName }}
                              </div>
                              <div v-if="!disabled">
                                <el-button
                                  type="primary"
                                  @click.stop="AddComponentDeviceData(item)"
                                  >添加{{
                                    item.ComponentDeviceTypeName
                                  }}信息</el-button
                                >
                              </div>
                            </div>
                          </template>
                          <el-table
                            :data="
                              DataInfo[ele.DicValue]?.filter(
                                (val) =>
                                  val.DeviceType === item.ComponentDeviceType
                              )
                            "
                            size="mini"
                            style="width: 100%"
                            max-height="400px"
                          >
                            <el-table-column
                              label="部件编号"
                              prop="device_no"
                              align="center"
                              sortable
                            ></el-table-column>
                            <el-table-column
                              label="部件名称"
                              prop="device_name"
                              align="center"
                              sortable
                            ></el-table-column>
                            <el-table-column
                              label="部件规格"
                              prop="specification"
                              align="center"
                              sortable
                            ></el-table-column>
                            <el-table-column
                              label="部件数量"
                              prop="Num"
                              align="center"
                              sortable
                            ></el-table-column>
                            <el-table-column
                              prop="op"
                              label="操作"
                              width="100px"
                            >
                              <template slot-scope="scope">
                                <el-button
                                  type="text"
                                  @click.stop="
                                    EditComponentDeviceData(scope.row, true)
                                  "
                                  v-if="disabled"
                                  >详情</el-button
                                >
                                <el-button
                                  type="text"
                                  @click.stop="
                                    EditComponentDeviceData(scope.row, false)
                                  "
                                  v-if="!disabled"
                                  >编辑</el-button
                                >
                                <el-button
                                  type="text"
                                  style="color: #f56c6c"
                                  v-if="!disabled"
                                  @click="DeteleComponentDeviceData(scope.row)"
                                  >删除</el-button
                                >
                              </template>
                            </el-table-column>
                          </el-table>
                        </el-collapse-item>
                      </el-collapse>
                    </div>
                    <!-- 备品配件 -->
                    <div v-if="ele.DicValue === 'SparePartsInformation'">
                      <el-table :data="DataInfo[ele.DicValue]" size="mini">
                        <el-table-column
                          v-for="tableItem in TemplateData[ele.DicValue]"
                          :key="tableItem.FiledKey"
                          :label="tableItem.FieldName"
                          :prop="tableItem.FiledKey"
                        >
                          <template slot-scope="scope">
                            <el-input
                              :disabled="disabled"
                              v-model="scope.row[tableItem.FiledKey]"
                              placeholder="请输入"
                              style="width: 100%"
                              :type="
                                tableItem.ComponentType === 'InputText'
                                  ? 'text'
                                  : 'number'
                              "
                              resize="none"
                              size="mini"
                            ></el-input>
                          </template>
                        </el-table-column>
                        <el-table-column
                          label="操作"
                          width="100px"
                          v-if="!disabled"
                        >
                          <template slot-scope="scope">
                            <el-button
                              type="text"
                              @click="
                                TableDeleteRow(scope.$index, ele.DicValue)
                              "
                              >删除</el-button
                            >
                          </template>
                        </el-table-column>
                      </el-table>
                      <el-button
                        v-if="!disabled"
                        icon="el-icon-plus"
                        circle
                        style="font-size: 14px"
                        type="primary"
                        @click="TableAddRow(ele.DicValue)"
                      ></el-button>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
            <div
              style="
                width: 180px;
                height: calc(100vh - 150px);
                position: fixed;
                right: 40px;
                top: 100px;
              "
              class="steps-box"
            >
              <div style="height: 100%">
                <div
                  v-for="(ele, index) in TabData"
                  :key="ele.DicValue"
                  :style="`height: calc(100% / ${TabData.length});`"
                >
                  <div style="height: 100%; display: flex">
                    <div class="steps-left">
                      <div
                        :class="[
                          'steps',
                          DataInfo[ele.DicValue + 'Status'] == 1
                            ? 'steps-success'
                            : '',
                        ]"
                        @click="anchorClick(ele.DicValue, index)"
                      >
                        <i
                          class="el-icon-check"
                          v-if="DataInfo[ele.DicValue + 'Status'] == 1"
                        ></i>
                        <span v-else>{{ index + 1 }}</span>
                      </div>
                      <div
                        :class="[
                          'steps-left-line',
                          DataInfo[ele.DicValue + 'Status'] == 1
                            ? 'steps-success-line'
                            : '',
                        ]"
                        v-if="index != TabData.length - 1"
                      ></div>
                    </div>
                    <div class="steps-right">
                      <div class="steps-right-title">
                        <span
                          :class="[
                            DataInfo[ele.DicValue + 'Status'] == 1
                              ? 'steps-success'
                              : '',
                          ]"
                          style="cursor: pointer"
                          @click="anchorClick(ele.DicValue, index)"
                          >{{ index + 1 }}.{{ ele.DicName }}</span
                        >
                      </div>
                      <div
                        class="steps-right-description"
                        v-if="
                          approvalComments[ele.DicValue] &&
                          approvalComments[ele.DicValue]?.content &&
                          (DataInfo.Status == 2 ||
                            DataInfo.Status == 3 ||
                            DataInfo.Status == 4)
                        "
                      >
                        <div class="approval-comment">
                          <el-tooltip
                            effect="dark"
                            placement="left"
                            :open-delay="300"
                          >
                            <div slot="content" style="width: 300px">
                              {{ approvalComments[ele.DicValue].content }}
                            </div>
                            <div class="comment-content">
                              {{ approvalComments[ele.DicValue].content }}
                            </div>
                          </el-tooltip>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div
              style="
                width: 140px;
                height: calc(100vh - 300px);
                position: fixed;
                right: 50px;
                top: 100px;
              "
            >
              <el-steps direction="vertical">
                <el-step
                  v-for="(ele, index) in TabData"
                  :key="ele.DicValue"
                  :disabled="disabled"
                  :status="
                    DataInfo[ele.DicValue + 'Status'] == 1 ? 'success' : 'wait'
                  "
                >
                  <span slot="title" style="cursor: pointer">
                    <span @click="anchorClick(ele.DicValue, index)">
                      <span>{{ index + 1 }}.</span>{{ ele.DicName }}</span
                    >
                  </span>
                </el-step>
              </el-steps>
            </div> -->
          </div>
        </el-card>
      </div>
    </el-drawer>
    <el-dialog
      title="驳回原因"
      :visible.sync="rejectVisible"
      width="400px"
      top="20vh"
    >
      <el-input
        type="textarea"
        disabled
        :autosize="true"
        placeholder="请输入内容"
        v-model="DataInfo.RejectReason"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="rejectVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- <TemplateFormInfoAssembly
      ref="TemplateFormInfoAssembly"
      @success="TemplateFormInfoAssemblyChange"
    ></TemplateFormInfoAssembly> -->
  </div>
</template>
<script>
import TokenCache from '@/utils/cache/TokenCache'
// import TemplateFormInfoAssembly from './TemplateFormInfoAssembly'
export default {
  data() {
    return {
      rejectVisible: false,
      drawer: false,
      tabsTrue: false,
      leftLoading: false,
      rightLoading: false,
      TokenCache,
      // DataInfo.DeviceTab: "",
      ProjectInfo: {},
      token: '',
      loading: false,
      isLogin: false,
      errStrte: false,
      ProjectId: '',
      filterText: '',
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'title',
      },
      TabData: [],
      TemplateData: {},
      form: {},
      DataInfo: {
        // Success: false,
        // DeviceTab: "",
        // Data: {},
      },
      treeId: '',
      SupplierId: '',
      base_Supplier: [],
      isUp: false,
      isUpCheckbox: false,
      disabled: false,
      collapseValue: [],
      // BuildingId: "",
      // BuildingFloor: [],
      BuildingFloorList: [],
      //楼栋列表
      BuildingData: [],
      //安装位置
      InstallationAreaData: [],
      InstallationAreaValue: '',
      DeviceId: '',
      tabObj: {},
      TreeName: '',
      ParentDeviceId: '',
      DeviceObj: {},
      approvalComments: {},
    }
  },
  props: {},
  components: {},
  methods: {
    TemplateFormInfoAssemblyChange(row) {
      console.log(row)
      let findIndex = this.DataInfo['Device_Components'].findIndex((item) => {
        return item.Id == row.Id
      })
      if (findIndex !== -1) {
        this.$set(this.DataInfo['Device_Components'], findIndex, {
          ...row,
        })
      } else {
        this.DataInfo['Device_Components'].push({
          ...row,
        })
      }
    },
    DeteleComponentDeviceData(row) {
      this.$confirm('此操作将永久删除该部件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http
          .post(
            `/Device_TypeWork/Device_TypeTemplate/DeleteDeviceComponentsData?Id=${row.Id}`
          )
          .then((res) => {
            if (res.Success) {
              let findIndex = this.DataInfo['Device_Components'].findIndex(
                (item) => {
                  return item.Id == row.Id
                }
              )
              this.DataInfo['Device_Components'].splice(findIndex, 1)
              this.$notify.success('删除成功')
            } else {
              this.$notify.error(res.Msg)
            }
          })
      })
    },
    EditComponentDeviceData(item, isTrue) {
      let obj = this.TemplateData['Device_Components'].find((vv) => {
        return vv.ComponentDeviceType == item.DeviceType
      })
      // 部件弹出
      this.$refs.TemplateFormInfoAssembly.openDrawer(
        item.DeviceType, //部件分类ID
        item.ProjectId, //项目ID
        item.SupplierId, //供应商ID
        item.Id, //部件ID 新建不传
        obj?.ComponentDeviceTypeName || '', //部件分类名称
        isTrue, //是否查看禁用
        item.DeviceId //当前的设备ID 部件的父级ID
        // //设备位置信息
        // {
        //   InstallationArea: this.DataInfo.InstallationArea, //安装位置
        //   BuildingId: this.DataInfo.BuildingId, //楼栋
        //   BuildingFloor: this.DataInfo.BuildingFloor, //楼层
        // }
      )
    },
    //添加部件信息弹窗
    AddComponentDeviceData(item) {
      if (!this.DeviceId) {
        return this.$notify.error(`请先保存${this.tabObj.DicName}后添加`)
      }
      // 部件弹出
      this.$refs.TemplateFormInfoAssembly.openDrawer(
        item.ComponentDeviceType, //部件分类ID
        this.ProjectId, //项目ID
        this.SupplierId, //供应商ID
        '', //部件ID 新建不传
        item.ComponentDeviceTypeName, //部件分类名称
        false, //是否查看禁用
        this.DeviceId, //当前的设备ID 部件的父级ID
        //设备位置信息
        {
          InstallationArea: this.DataInfo.InstallationArea, //安装位置
          BuildingId: this.DataInfo.BuildingId, //楼栋
          BuildingFloor: this.DataInfo.BuildingFloor, //楼层
        }
      )
    },
    //文档保存动作
    DocumentSubmit(ele) {
      if (!this.DeviceId) {
        return this.$notify.error(`请先保存${this.tabObj.DicName}后上传文档`)
      }
      let arr = []
      console.log(this.TemplateData[ele.DicValue], '222')
      this.TemplateData[ele.DicValue].forEach((item) => {
        item.device_TypeTwoDocuments.forEach((val) => {
          if (
            val.disabled == 1 &&
            this.DataInfo[ele.DicValue][val.Type] &&
            this.DataInfo[ele.DicValue][val.Type].length <= 0
          ) {
            arr.push(val)
          }
        })
      })
      if (arr.length > 0) {
        return this.$notify.error(
          '请上传' +
            arr.map((item) => item.TypeName).join('、') +
            '全部文件后进行保存'
        )
      }
      console.log(this.DataInfo[ele.DicValue])
      console.log(arr, 'arr')
      this.loading = true
      this.$http
        .post('/Device_TypeWork/Device_TypeTemplate/SubmitDeviceDocumentData', {
          DeviceIds: [this.DeviceId],
          PrivateOrShared: 1,
          ParentDeviceId: this.ParentDeviceId || '',
        })
        .then((res) => {
          this.loading = false
          if (res.Success) {
            this.$notify.success('文档保存成功')
            this.$emit('success')
            // this.DataInfo[ele.DicValue + 'Status']
            this.$set(this.DataInfo, [ele.DicValue + 'Status'], 1)
          }
        })
    },
    //锚点
    anchorClick(value, index) {
      var a = document.createElement('a')
      a.href = `#${index === 0 ? 'Device' : value}`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    //删除数据
    TableDeleteRow(index, DicValue) {
      console.log(index, DicValue)
      this.DataInfo[DicValue].splice(index, 1)
    },
    //添加数据
    TableAddRow(DicValue) {
      this.DataInfo[DicValue]
      let obj = {}
      this.TemplateData[DicValue].forEach((item) => {
        this.$set(obj, item.FiledKey, '')
      })
      this.$set(this.DataInfo[DicValue], this.DataInfo[DicValue].length, obj)
    },
    //选择安装位置
    async changeInstallationArea(Id) {
      this.DataInfo.BuildingId = ''
      this.DataInfo.BuildingFloor = ''
      console.log(Id)
      if (Id) {
        let obj = this.InstallationAreaData.find((item) => {
          return item.Id == Id
        })
        console.log(obj, 'obk')
        this.InstallationAreaValue = obj.DicValue
      }

      // this.DataInfo.BuildingFloor = "";
      // console.log(Id);
      // let obj = this.BuildingData.find((item) => {
      //   return item.Id == Id;
      // });
      // this.BuildingFloorList = obj.BuildingFloor;
    },
    //选择楼栋
    async changeBuilding(Id) {
      this.DataInfo.BuildingFloor = ''
      console.log(Id)
      let obj = this.BuildingData.find((item) => {
        return item.Id == Id
      })
      this.BuildingFloorList = obj.BuildingFloor
    },
    async openDrawer(
      treeId, //选择的设备分类ID
      ProjectId, //项目ID
      SupplierId, //供应商ID
      DeviceId, //设备ID
      TreeName, //选择的分类名称
      disabled, //是否禁用
      ParentDeviceId, //如为部件则是部件的上级设备ID
      DeviceObj //设备位置信息
    ) {
      this.TreeName = TreeName
      this.treeId = treeId
      this.ProjectId = ProjectId
      this.SupplierId = SupplierId
      this.DeviceId = DeviceId || ''
      this.ParentDeviceId = ParentDeviceId || ''
      this.DeviceObj = DeviceObj || {}
      this.disabled = disabled ? true : false
      this.isUpCheckbox = false
      this.drawer = true
      this.collapseValue = []
      this.InstallationAreaValue = ''
      this.approvalComments = {}
      await this.getInfoData()
      this.getDataList()
    },
    beforeClose(done) {
      if (!this.disabled) {
        this.$confirm(
          '请确认是否已保存数据，关闭后未保存的数据将清空，确认关闭吗？',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        )
          .then(() => {
            this.drawer = false
            if (done) {
              done()
            }
          })
          .catch(() => {})
      } else {
        this.drawer = false
        if (done) {
          done()
        }
      }
    },
    //获取数据信息
    async getInfoData() {
      this.loading = true
      await this.$http
        .post('/Device_TypeWork/Device_TypeTemplate/GetSupplierData', {
          ParentDeviceId: this.ParentDeviceId || '',
          DeviceId: this.DeviceId || '',
          DeviceType: this.treeId,
          ProjectId: this.ProjectId,
          SupplierId: this.SupplierId,
        })
        .then(async (res) => {
          this.loading = false
          if (res.Success) {
            this.$set(this, 'DataInfo', res.Data)
            //批注信息

            if (
              res.Data.ApprovalCommentsData &&
              JSON.parse(res.Data.ApprovalCommentsData).length > 0
            ) {
              JSON.parse(res.Data.ApprovalCommentsData).forEach((item) => {
                this.$set(this.approvalComments, item.stepKey, item)
              })
              console.log(this.approvalComments, 'this.approvalComments')
            }
            // this.DataInfo = res.Data;
          } else {
            this.closeDrawer()
            this.$notify.error(res.Msg)
          }
        })
    },
    //获取模板信息
    getDataList() {
      this.loading = true
      this.$http
        .post(
          '/Device_TypeWork/Device_TypeTemplate/GetSupDeviceTypeTemplateData',
          {
            ProjectId: this.ProjectId,
            DeviceType: this.treeId,
          }
        )
        .then(async (res) => {
          if (res.Success) {
            this.loading = false
            this.TabData = res.Data.TabData
            //选项卡基本信息
            this.tabObj =
              this.TabData.find((item) => {
                return item.DicValue == 'BasicInformation'
              }) || {}
            this.TemplateData = res.Data.TemplateData

            this.BuildingData = res.Data.BuildingData || []

            // res.Data.ApprovalCommentsData || []
            // this.approvalComments =
            this.InstallationAreaData = res.Data.InstallationAreaData || []
            let obj = this.InstallationAreaData.find((item) => {
              return item.Id == this.DataInfo.InstallationArea
            })
            if (obj) {
              this.InstallationAreaValue = obj.DicValue
            }

            this.TabData.forEach((item) => {
              this.collapseValue.push(item.DicValue)
            })
            this.TemplateData['DocumentInformation']?.forEach((item) => {
              item.device_TypeTwoDocuments.forEach((val) => {
                this.$set(val, 'checked', false)
              })
              item.cList.forEach((val) => {
                //回填获取TypeList
                this.$set(
                  this.DataInfo['DocumentInformation'],
                  val,
                  this.DataInfo['DocumentInformation'][val] || []
                )
                //复制渲染数据挂载上传组件 上传组件用type+List方式为fileList
                this.$set(
                  this.DataInfo['DocumentInformation'],
                  val + 'List',
                  JSON.parse(
                    JSON.stringify(
                      this.DataInfo['DocumentInformation'][val] || []
                    )
                  ) || []
                )
                this.$set(
                  this.DataInfo['DocumentInformation'],
                  val + 'UpStatus',
                  false
                )
              })
            })
            //是否为部件 为部件则带入位置信息
            if (this.DeviceObj && this.DeviceObj.InstallationArea) {
              this.DataInfo.InstallationArea = this.DeviceObj.InstallationArea
              await this.changeInstallationArea(this.DeviceObj.InstallationArea)
            }
            if (this.DeviceObj && this.DeviceObj.BuildingId) {
              this.DataInfo.BuildingId = this.DeviceObj.BuildingId
              await this.changeBuilding(this.DeviceObj.BuildingId)
            }
            if (this.DeviceObj && this.DeviceObj.BuildingFloor) {
              this.DataInfo.BuildingFloor = this.DeviceObj.BuildingFloor
            }
          } else {
            this.loading = false
            this.closeDrawer()
            this.$notify.error(res.Msg)
          }
        })
    },
    closeDrawer() {
      this.drawer = false
    },
    handlePreview(file) {
      console.log(file)

      window.open(file.url || file.response.Url || file.response.url)
    },
    submitDataUp() {
      this.$confirm('确定保存当前设备数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.loading = true
        this.$http
          .post(
            '/Device_TypeWork/Device_TypeTemplate/SubmitTemplateSupplierData?DeviceType=' +
              this.treeId
          )
          .then((res) => {
            this.loading = false
            if (res.Success) {
              this.$notify.success('保存成功')
              this.TemplateData = {}
              this.form = {}
              this.TabData = []
              this.tabsTrue = false
              this.disabled = false
              this.treeId = ''
              this.DataInfo = {
                Success: false,
                DeviceTab: '',
                Data: {},
              }
              this.$refs.tree.setCurrentKey(null)
            } else {
              this.$notify.error(res.Msg)
            }
          })
      })
    },
    //字节转换
    setSize(size) {
      let data = ''
      const _size = Number.parseFloat(size)
      if (_size < 1 * 1024) {
        //如果小于0.1KB转化成B
        data = _size.toFixed(2) + 'B'
      } else if (_size < 1 * 1024 * 1024) {
        //如果小于0.1MB转化成KB
        data = (_size / 1024).toFixed(2) + 'KB'
      } else if (_size < 1 * 1024 * 1024 * 1024) {
        //如果小于0.1GB转化成MB
        data = (_size / (1024 * 1024)).toFixed(2) + 'MB'
      } else {
        //其他转化成GB
        data = (_size / (1024 * 1024 * 1024)).toFixed(2) + 'GB'
      }
      const size_str = data + ''
      const len = size_str.indexOf('.')
      const dec = size_str.substr(len + 1, 2)
      if (dec == '00') {
        //当小数点后为00时 去掉小数部分
        return size_str.substring(0, len) + size_str.substr(len + 3, 2)
      }
      return size_str
    },
    //全选选择
    upCheckboxChange(val) {
      console.log(val, '全选')
      if (val) {
        this.TemplateData['DocumentInformation']?.forEach((item) => {
          let data = item.device_TypeTwoDocuments.filter((vall) =>
            item.cList.includes(vall.Type)
          )
          data.forEach((ele) => {
            console.log(ele, '22222')

            this.$set(ele, 'checked', true)
          })
        })
      } else {
        this.TemplateData['DocumentInformation']?.forEach((item) => {
          let data = item.device_TypeTwoDocuments.filter((vall) =>
            item.cList.includes(vall.Type)
          )
          data.forEach((ele) => {
            console.log(ele, '22222')

            this.$set(ele, 'checked', false)
          })
        })
      }
    },
    //选择多选
    checkedChange(row) {
      console.log(row, '选择多选')
      let arr = this.TemplateData['DocumentInformation']?.map((item) => {
        return item.device_TypeTwoDocuments.filter((vall) =>
          item.cList.includes(vall.Type)
        )
      })
      let ArrData = arr.flat(9999999)
      this.isUpCheckbox = ArrData.every((val) => {
        return val.checked
      })

      //  this.TemplateData[this.DataInfo.DeviceTab].forEach((item) => {
      //     let data = item.device_TypeTwoDocuments.filter((vall) =>
      //       item.cList.includes(vall.Type)
      //     );
      //     data.forEach((ele) => {
      //       console.log(ele, "22222");

      //       this.$set(ele, "checked", true);
      //     });
      //   });
      console.log(row)
    },
    //上传全部
    async upAllData() {
      if (!this.DeviceId) {
        return this.$notify.error(`请先保存${this.tabObj.DicName}后上传文档`)
      }
      //获取所有table数据
      let arr = this.TemplateData['DocumentInformation']?.map((item) => {
        return item.device_TypeTwoDocuments.filter((vall) =>
          item.cList.includes(vall.Type)
        )
      })
      // 获取选中的数据
      let ArrData = arr.flat(9999999).filter((item) => {
        return item.checked
      })
      if (ArrData.length <= 0) {
        return this.$notify.error('请选择需要上传的文档信息')
      }
      //验证是否选中的项都有文件
      let errArr = []
      ArrData.forEach((item) => {
        if (
          this.DataInfo['DocumentInformation'][item.Type + 'List'].length <= 0
        ) {
          errArr.push(item)
        }
      })
      if (errArr.length > 0) {
        return this.$notify.error('选择的文档信息中有未选择文件，请核实后上传')
      }
      //判断选中的都已上传过 如选中的都已保存过则循环重新保存一次
      let ArrDataSuccess = []
      ArrData.forEach((item) => {
        let flag = this.DataInfo['DocumentInformation'][
          item.Type + 'List'
        ].every((val) => {
          return val.status == 'success'
        })
        // 选中的为上传则执行上传组件
        if (flag) {
          ArrDataSuccess.push(item)
        } else {
          console.log(item, 'itemitem')
          //使当前上传按钮为上传中状态
          item.IsUpStatus = true
          this.$refs['upload_' + item.Type][0].submit()
        }
      })

      //判断选中的都已上传过 如选中的都已保存过则循环重新保存一次
      if (ArrDataSuccess.length === ArrData.length) {
        for await (const item of ArrData) {
          await this.submitData(item)
        }
        console.log('00000000000000000000000000000000000000')
        // ArrData.forEach((item) => {
        //   this.submitData(item.Type);
        // });
      } else {
        for await (const item of ArrDataSuccess) {
          await this.submitData(item)
        }
      }
      console.log(ArrData)
    },
    //上传按钮
    upData(row) {
      if (!this.DeviceId) {
        return this.$notify.error(`请先保存${this.tabObj.DicName}后上传文档`)
      }
      if (this.DataInfo['DocumentInformation'][row.Type + 'List'].length <= 0) {
        return this.$notify.error('请选择需要上传的文件')
      }

      //判断当前行是否全部文件已上传过 上传过则执行一次保存
      let flag = this.DataInfo['DocumentInformation'][row.Type + 'List'].every(
        (val) => {
          return val.status == 'success'
        }
      )
      if (flag) {
        this.submitData(row)
        return
      }
      // 未上传 则执行上传组件执行上传
      row.IsUpStatus = true
      this.$refs['upload_' + row.Type][0].submit()
    },
    getget(sc, item) {
      console.log(this.DataInfo, 'this,DataInfo')
      console.log(sc, 'sc')
      console.log(item, 'item')
    },
    handleExceed(files, fileList) {
      this.$notify.warning(
        `当前限制选择 9 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      )
    },
    beforeUpload(row, file, fileList) {
      if (!this.DeviceId) {
        this.$notify.error(`请先保存${this.tabObj.DicName}后上传文档`)
        return false
      }
      const isImage = file.type.startsWith('image/')
      const allowedDocumentExtensions = [
        'pdf',
        'doc',
        'docx',
        'xls',
        'xlsx',
        'ppt',
        'pptx',
      ]
      const fileExtension = file.name.split('.').pop().toLowerCase()

      // 验证是否为图片或文档
      if (!isImage && !allowedDocumentExtensions.includes(fileExtension)) {
        this.$notify.error('只能上传图片或文档文件！')
        return false
      } else {
        row.IsUpStatus = true
        return true
      }
    },
    beforeRemove(file, item) {
      console.log(file, item, '删除之前文件')
      const isImage = file?.raw?.type.startsWith('image/')
      const allowedDocumentExtensions = [
        'pdf',
        'doc',
        'docx',
        'xls',
        'xlsx',
        'ppt',
        'pptx',
      ]
      const fileExtension = file.name.split('.').pop().toLowerCase()
      if (!isImage && !allowedDocumentExtensions.includes(fileExtension)) {
        return true
      }
      return new Promise((response, reject) => {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            console.log(file)
            return response()
          })
          .catch(() => {
            return reject()
          })
      })
    },
    //上传删除文件
    async handleRemove(file, fileList, row) {
      console.log(file, fileList, row, '删除文件')
      this.DataInfo['DocumentInformation'][row.Type + 'List'] = fileList
      // console.log(this.form[item.FiledKey + "fileList"], "fileList");
      let index = this.DataInfo['DocumentInformation'][row.Type].findIndex(
        (val) => {
          return val.uid === file.uid
        }
      )
      if (index > -1) {
        this.DataInfo['DocumentInformation'][row.Type].splice(index, 1)
      }
      if (file.status == 'success') {
        //如果已上传的删除则执行删除接口
        this.submitData(row, true)
      }
    },
    //上传成功
    handleSuccess(response, file, fileList, row) {
      console.log(
        JSON.parse(
          JSON.stringify({
            response,
            file,
            fileList,
            row,
          })
        ),
        '22222222222222'
      )
      console.log(
        JSON.parse(
          JSON.stringify(
            this.DataInfo['DocumentInformation'][row.Type + 'List']
          )
        ),
        'List'
      )

      //上传成功的赋值到保存参数里
      if (response.code == '200' && file.status == 'success') {
        this.DataInfo['DocumentInformation'][row.Type] = [
          ...this.DataInfo['DocumentInformation'][row.Type],
          {
            name: file.name,
            size: file.size,
            uid: file.uid,
            url: file.response.url,
            status: file.status,
            resname: response.name,
          },
        ]
        console.log(
          this.DataInfo['DocumentInformation'][row.Type],
          'TypeTypeTypeTypeTypeType'
        )
      }
      //验证是否全部上传完毕
      this.DataInfo['DocumentInformation'][row.Type + 'UpStatus'] =
        fileList.every((val) => {
          return val.status == 'success'
        })
      //全部上传完毕保存数据
      if (this.DataInfo['DocumentInformation'][row.Type + 'UpStatus']) {
        row.IsUpStatus = false
        this.submitData(row)
      }
    },
    //上传失败
    handleError(err, file, fileList, row) {
      console.log(err, file, fileList, row, '上传失败')
      row.IsUpStatus = false
      this.$notify.error('上传失败')
    },
    //文件改变状态
    handleChange(file, fileList, Type) {
      // this.form[item.FiledKey + "fileList"] = [...fileList];
      this.DataInfo['DocumentInformation'][Type + 'List'] = [...fileList]
      // console.log(file, fileList, item, "文件改变状态");
    },
    temporaryData() {
      console.log('暂存数据')
      this.$confirm('将暂存当前数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        window.localStorage.setItem(
          'temporaryData',
          JSON.stringify({
            treeId: this.treeId,
            form: this.form,
          })
        )
        // 暂存成功
      })
    },
    //文档信息保存
    async submitData(item, isDete) {
      console.log(item, 'item')
      console.log('上传完成1233333333333333333333')

      let obj = {}
      this.$set(obj, item.Type, this.DataInfo['DocumentInformation'][item.Type])
      console.log({
        DeviceType: this.treeId,
        DeviceTab: 'DocumentInformation',
        Type: item.Type,
        DataJson: obj,
      })

      // Device_TypeWork/Device_TypeTemplate/SaveTemplateSupplierData
      this.loading = true
      await this.$http
        .post('/Device_TypeWork/Device_TypeTemplate/SaveTemplateSupplierData', {
          //如为部件则是部件的上级设备ID
          ParentDeviceId: this.ParentDeviceId || '',
          //设备ID或部件ID
          DeviceId: this.DeviceId || '',
          DeviceType: this.treeId,
          ProjectId: this.ProjectId,
          BuildingId: this.DataInfo.BuildingId,
          BuildingFloor: this.DataInfo.BuildingFloor,
          InstallationArea: this.DataInfo.InstallationArea,
          DeviceTab: 'DocumentInformation',
          SupplierId: this.SupplierId,
          DataJson: JSON.stringify(obj),
        })
        .then((res) => {
          this.loading = false
          if (res.Success) {
            if (!isDete) {
              this.$notify.success(`【${item.TypeName}】文档信息上传保存成功`)
            } else {
              this.$notify.success(`删除成功`)
            }
            this.$set(this.DataInfo, ['DocumentInformationStatus'], 0)
            this.DeviceId = res.Data?.Id || ''
            this.$emit('success', res.Data)
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    //基本信息 配置信息 保存数据
    saveData(DicValue, DicName) {
      if (DicValue !== 'BasicInformation') {
        if (!this.DeviceId) {
          return this.$notify.error(
            `请先保存${this.tabObj.DicName}后保存其他信息`
          )
        }
      }
      //非文档与配件信息时的保存
      if (
        DicValue !== 'DocumentInformation' &&
        DicValue !== 'SparePartsInformation'
      ) {
        if (!this.DataInfo.InstallationArea) {
          return this.$notify.error(`请选择安装位置`)
        } else {
          if (this.InstallationAreaValue === 'Indoor') {
            if (!this.DataInfo.BuildingId) {
              return this.$notify.error(`请选择楼栋`)
            }
            if (
              this.DataInfo.BuildingId !== '其他' &&
              !this.DataInfo.BuildingFloor
            ) {
              return this.$notify.error(`请选择楼层`)
            }
            // if (!this.DataInfo.BuildingId || !this.DataInfo.BuildingFloor) {
            //   return this.$notify.error(`请选择楼栋楼层`)
            // }
          }
        }
        let arr = this.TemplateData[DicValue].filter((item) => {
          return item.Enable == true || item.disabled == 1
        })
        let err = []
        arr.forEach((item) => {
          if (
            this.DataInfo[DicValue][item.FiledKey] === '' ||
            this.DataInfo[DicValue][item.FiledKey] === undefined ||
            this.DataInfo[DicValue][item.FiledKey] === null
          ) {
            err.push(item)
          }
        })
        if (err.length > 0) {
          let str = ''
          err.forEach((item) => {
            str += `【${item.FieldName}】、`
          })
          return this.$notify.error(`${str}未填写，请检查`)
        }
      } else if (DicValue === 'SparePartsInformation') {
        if (this.DataInfo[DicValue].length <= 0) {
          return this.$notify.error('请添加信息后保存')
        }
      }

      this.$confirm(`将保存当前${DicName}数据, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.loading = true
        this.$http
          .post(
            '/Device_TypeWork/Device_TypeTemplate/SaveTemplateSupplierData',
            {
              //如为部件则是部件的上级设备ID
              ParentDeviceId: this.ParentDeviceId || '',
              //设备ID或部件ID
              DeviceId: this.DeviceId || '',
              DeviceType: this.treeId,
              ProjectId: this.ProjectId,
              BuildingId: this.DataInfo.BuildingId,
              BuildingFloor: this.DataInfo.BuildingFloor,
              InstallationArea: this.DataInfo.InstallationArea,
              DeviceTab: DicValue,
              SupplierId: this.SupplierId,
              DataJson: JSON.stringify(this.DataInfo[DicValue]),
            }
          )
          .then((res) => {
            this.loading = false
            if (res.Success) {
              this.$notify.success('保存成功')
              this.DeviceId = res.Data?.Id || ''
              // this.DataInfo[DicValue + "Status"] = 1;
              this.$set(this.DataInfo, DicValue + 'Status', 1)
              this.$emit('success', res.Data)
            } else {
              this.$notify.error(res.Msg)
            }
          })
      })
    },
    //tabs切换前
    beforeLeave(activeName, oldActiveName) {
      console.log(
        this.DataInfo.DeviceTab,
        'this.DataInfo.DeviceTa222222222222b'
      )
      console.log(activeName, oldActiveName, '2222222222222222222222')
      console.log(this.disabled, 'this.disabled')
      console.log(this.tabsTrue, 'this.tabsTrue')
      if (activeName == '') {
        return true
      }
      if (this.disabled) {
        this.getFormData(activeName)
        return true
      }
      if (activeName == 0 && oldActiveName == undefined) {
        return true
      }
      // console.log(this.DataInfo);
      // console.log(this.treeId);
      // console.log(oldActiveName == 0, "oldActiveName");

      if (this.tabsTrue) {
        console.log(111111)
        this.getFormData(activeName)
        this.tabsTrue = false
        return true
      }

      if (oldActiveName == 0 || oldActiveName == undefined) {
        this.getFormData(activeName)
        return true
      }

      return new Promise((response, reject) => {
        this.$confirm(
          '请确认是否修改后已保存,切换后数据将会丢失, 是否继续?',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        )
          .then(() => {
            this.getFormData(activeName)

            return response()
          })
          .catch(() => {
            return reject()
          })
      })
    },

    //树过滤节点
    filterNode(value, data) {
      if (!value) return true
      return data.title.indexOf(value) !== -1
    },
    //获取选项卡下信息
    getFormData(DeviceTab) {
      this.rightLoading = true
      this.$http
        .post('/Device_TypeWork/Device_TypeTemplate/GetTemplateSupplierData', {
          DeviceType: this.treeId,
          DeviceTab: DeviceTab,
        })
        .then((res) => {
          this.rightLoading = false
          if (res.Success) {
            this.disabled = res.Data.Status == 1 ? true : false
            if (res.Data.Success) {
              if (DeviceTab === 'DocumentInformation') {
                let obj = {}
                let DataJson = res.Data.DataJson
                  ? JSON.parse(res.Data.DataJson)
                  : {}
                this.TemplateData[DeviceTab].forEach((item) => {
                  item.cList.forEach((val) => {
                    this.$set(obj, val, DataJson[val])
                    this.$set(obj, val + 'List', DataJson[val])
                    this.$set(obj, val + 'UpStatus', false)
                  })
                })
                this.$set(this.DataInfo, DeviceTab, obj)
              } else {
                this.$set(
                  this.DataInfo,
                  DeviceTab,
                  res.Data.DataJson ? JSON.parse(res.Data.DataJson) : {}
                )
              }
            } else {
              if (DeviceTab === 'DocumentInformation') {
                //上传组件赋值
                let obj = {}
                this.TemplateData[DeviceTab].forEach((item) => {
                  item.cList.forEach((val) => {
                    this.$set(obj, val, [])
                    this.$set(obj, val + 'List', [])
                    this.$set(obj, val + 'UpStatus', false)
                  })
                })
                this.$set(this.DataInfo, DeviceTab, obj)
                console.log(
                  this.DataInfo[DeviceTab],
                  'this.DataInfo[DeviceTab]'
                )
              }
            }

            this.DataInfo.Success = res.Data.Success
            // if(DeviceTab==='DocumentInformation'){
            //   this.TemplateData[DeviceTab].forEach(item=>{
            //     // this.$set(this.DataInfo[DeviceTab],item.FiledKey,{})
            //     item.cList.forEach(val=>{
            //       this.$set(this.DataInfo[DeviceTab],val,[])
            //     })
            //   })
            //   console.log(this.DataInfo[DeviceTab],'this.DataInfo[DeviceTab]')
            //   console.log(this.TemplateData[DeviceTab],'this.TemplateData[DeviceTab]')

            // }
            // this.form = res.Data.DataJson ? JSON.parse(res.Data.DataJson) : {};
            // if (
            //   this.TemplateData.DocumentInformation &&
            //   this.TemplateData.DocumentInformation.length > 0
            // ) {
            //   this.TemplateData.DocumentInformation.forEach((item) => {
            //     this.$set(
            //       this.form,
            //       item.FiledKey + "fileList",
            //       this.form[item.FiledKey]
            //     );
            //   });
            // }
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    handleNodeClick(data) {
      if (!data.children) {
        if (this.treeId) {
          this.$confirm(
            '请确认是否已保存数据，切换分类后当前数据将会清空, 是否切换分类?',
            '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }
          )
            .then(() => {
              this.TemplateData = {}
              this.form = {}
              this.TabData = []
              this.tabsTrue = true
              this.treeId = data.Id
              this.disabled = false
              if (!data.Content) {
                return this.$notify.error('该设备类型暂无模板信息')
              }
              //获取选项卡信息

              console.log(this.DataInfo.DeviceTab)
              console.log('222222222222222222')
              if (data.sourceConents.length > 0) {
                this.TemplateData = data.Content ? JSON.parse(data.Content) : {}
                console.log('第二次点击树')

                //如果是当前选项卡信息与切换后的选项卡信息一致则会不触发tab切换事件 所以单独触发一下
                if (this.DataInfo.DeviceTab === data.sourceConents[0].Value) {
                  this.tabsTrue = false
                  this.getFormData(this.DataInfo.DeviceTab)
                }

                this.DataInfo.DeviceTab = data.sourceConents[0].Value
                data.sourceConents.forEach((item) => {
                  //继续文档选项卡特殊处理
                  if (item.Value === 'DocumentInformation') {
                    //上传组件赋值
                    let obj = {}
                    this.TemplateData[item.Value].forEach((ele) => {
                      ele.cList.forEach((val) => {
                        this.$set(obj, val, [])
                        this.$set(obj, val + 'List', [])
                        this.$set(obj, val + 'UpStatus', false)
                      })
                    })
                    this.$set(this.DataInfo, item.Value, obj)
                    console.log(
                      JSON.parse(JSON.stringify(this.DataInfo)),
                      'this.DataInfo'
                    )
                  } else {
                    this.$set(this.DataInfo, item.Value, {})
                  }
                })
                this.TabData = data.sourceConents
                // this.tabsTrue = false;
                // this.getFormData(this.DataInfo.DeviceTab)
              } else {
                return this.$notify.error('该设备类型暂无模板信息')
              }

              // this.getFormData();
            })
            .catch(() => {
              this.$refs.tree.setCurrentKey(this.treeId)
            })
          return
        }
        this.treeId = data.Id
        if (!data.Content) {
          return this.$notify.error('该设备类型暂无模板信息')
        }
        //获取选项卡信息

        if (data.sourceConents.length > 0) {
          this.TemplateData = data.Content ? JSON.parse(data.Content) : {}
          console.log('第一次点击树')
          this.tabsTrue = false
          //如果是当前选项卡信息与切换后的选项卡信息一致则会不触发tab切换事件 所以单独触发一下
          if (this.DataInfo.DeviceTab === data.sourceConents[0].Value) {
            this.getFormData(this.DataInfo.DeviceTab)
          }
          this.DataInfo.DeviceTab = data.sourceConents[0].Value
          data.sourceConents.forEach((item) => {
            //继续文档选项卡特殊处理
            if (item.Value === 'DocumentInformation') {
              //上传组件赋值
              let obj = {}
              this.TemplateData[item.Value].forEach((ele) => {
                ele.cList.forEach((val) => {
                  this.$set(obj, val, [])
                  this.$set(obj, val + 'List', [])
                  this.$set(obj, val + 'UpStatus', false)
                })
              })
              this.$set(this.DataInfo, item.Value, obj)
              console.log(
                JSON.parse(JSON.stringify(this.DataInfo)),
                'this.DataInfo'
              )
            } else {
              this.$set(this.DataInfo, item.Value, {})
            }
          })
          this.TabData = data.sourceConents
          // this.getFormData(this.DataInfo.DeviceTab)
        } else {
          return this.$notify.error('该设备类型暂无模板信息')
        }

        // this.getFormData();

        // this.getTabData(data.Id);
        // this.getTemplateInfo(data.Id);
      }
    },
    getTreeData() {
      this.leftLoading = true
      this.$http
        .post('/Device_TypeWork/Device_TypeTemplate/GetTemplateData', {
          ProjectId: this.ProjectId,
          SupplierId: this.base_Supplier.Id,
        })
        .then((res) => {
          this.leftLoading = false
          if (res.Success) {
            this.treeData = res.Data
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    leftDataSearch() {
      this.$refs.tree.filter(this.filterText)
    },
  },
  mounted() {},
  created() {
    // this.ProjectInfo = window.localStorage.getItem("ProjectInfo")
    //   ? JSON.parse(window.localStorage.getItem("ProjectInfo"))
    //   : {};
    // this.ProjectId = this.ProjectInfo.Id;
    // this.base_Supplier = window.localStorage.getItem("base_Supplier")
    //   ? JSON.parse(window.localStorage.getItem("base_Supplier"))
    //   : {};
    // this.getTreeData();
  },
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-tree-node {
  white-space: normal;
}

::v-deep .el-tree-node__content {
  height: 100%;
  align-items: start;
}

::v-deep .el-tree-node {
  padding-top: 2px;
  padding-bottom: 2px;
}

::v-deep
  .el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  background-color: #409eff;
  color: #fff;
  font-weight: bold;
}
::v-deep .el-tree-node {
  white-space: normal;
  .el-tree-node__content {
    height: 100%;
  }
}
::v-deep .el-table th .cell {
  font-weight: bold;
  font-size: 14px;
}
::v-deep .el-drawer__header {
  margin-bottom: 0px;
  padding: 10px;
  font-weight: bold;
  font-size: 18px;
}
::v-deep .el-upload-list {
  padding: 5px;
}
::v-deep .upload-demo {
  display: flex;
  align-items: center;
}
::v-deep .el-upload-list {
  width: calc(100% - 100px);
}
::v-deep .el-table th .cell {
  font-weight: bold;
  font-size: 14px;
  color: #000000;
}
// ::v-deep .header-class {
//   font-weight: bold;
//   .cell {
//     font-size: 14px;
//     color: #000;
//   }
// }
.steps-box {
  .steps-left {
    width: 25px;
    height: 100%;
    margin-right: 10px;
    .steps {
      width: 25px;
      height: 25px;
      border-radius: 50%;
      border: 2px solid #c0c4cc;
      color: #c0c4cc;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .steps-success {
      border: 2px solid #67c23a;
      color: #67c23a;
      font-size: 18px;
    }
    .steps-left-line {
      width: 2px;
      height: calc(100% - 25px);
      background: #c0c4cc;
      margin: 0 auto;
    }
    .steps-success-line {
      background: #67c23a;
    }
  }
  .steps-right {
    width: calc(100% - 35px);
    height: 100%;
    // overflow-y: auto;
    position: relative;
    .steps-success {
      color: #67c23a;
    }
    .steps-right-title {
      font-size: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: sticky;
      top: 0;
      background: #fff;
      z-index: 1;
    }
    .steps-right-description {
      font-size: 14px;

      padding-top: 10px;
      padding-bottom: 10px;
      padding-left: 5px;
      padding-right: 5px;
      height: calc(100% - 45px);
      overflow: hidden;
      position: relative;
      .comment-content {
        line-height: 1.6;
        color: #303133;
        word-wrap: break-word;
        word-break: break-all;
        white-space: pre-wrap;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        background-color: #f5f7fa;
        border-radius: 4px;
      }
    }
  }
}
</style>
